export default __webpack_public_path__ + "img/Montserrat-Regular_3220cdd.eot";